







import { Component, Prop, Vue } from 'vue-property-decorator';
import  Header  from './Header/Header.vue';
@Component({
  components:{
    Header,
  },
})
export default class HelloWorld extends Vue {
  @Prop() private msg!: string;
}
